import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { MenuNode } from '@x/ecommerce-shop/app/core/menu/services/menu.service';
import { MenuState } from '@x/ecommerce-shop/app/core/menu/state/menu.state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'x-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundComponent {
  @Input() heading: string = 'Oops! Page not found';
  @Input() alignment: 'left' | 'right' | 'center' = 'center';
  @Input() subHeading: string = 'The link you were looking for no longer exists.';
  @Input() backToShopping: boolean = true;
  @Input() newProducts: boolean = true;

  get bodyAlignment() {
    switch (this.alignment) {
      case 'left':
        return 'start';
      case 'right':
        return 'end';
      default:
        return this.alignment;
    }
  }

  newProductsMenuNode$: Observable<MenuNode | undefined> = this.store
    .selectOnce(MenuState.mainMenu)
    .pipe(map((items) => items?.find((i) => i.name === 'New')));

  constructor(private store: Store) {}
}
